import React, { createContext, useContext, useMemo, useState } from 'react'
import { BaseCurrencyConfig } from '@web/walter-lib/api/types/cms/config/returnTypes'
import { useCookies } from '@web/walter-lib/cookies'
import { defaultBaseCurrencies, useBaseCurrenciesList } from '~hooks/useBaseCurrenciesList'
import { baseCurrencyCookieName } from '~constants/cookies'
import { noop } from '~utils/noop'

interface BaseCurrencyState {
    baseCurrency: BaseCurrencyConfig
    setBaseCurrencyCode: (value: string) => void
}

interface Props {
    children: React.ReactNode
}

const defaultState: BaseCurrencyState = {
    baseCurrency: defaultBaseCurrencies[0],
    setBaseCurrencyCode: noop,
}

const BaseCurrencyContext = createContext<BaseCurrencyState>(defaultState)

export function BaseCurrencyProvider({ children }: Props) {
    const baseCurrencies = useBaseCurrenciesList()

    const cookies = useCookies()
    const initialValue: string = cookies?.get(baseCurrencyCookieName) || baseCurrencies[0].code

    const [baseCurrencyCode, setBaseCurrencyCode] = useState(initialValue)

    const contextValue = useMemo(() => {
        const baseCurrency = baseCurrencies.find(item => item.code === baseCurrencyCode) || baseCurrencies[0]

        const stateValue: BaseCurrencyState = {
            baseCurrency,
            setBaseCurrencyCode,
        }

        return stateValue
    }, [baseCurrencyCode, baseCurrencies])

    return <BaseCurrencyContext.Provider value={contextValue}>{children}</BaseCurrencyContext.Provider>
}

export const useBaseCurrencyContext = () => useContext(BaseCurrencyContext)
